import styled from 'styled-components'

type Props = {
	$isDisabled: boolean
}

export const CardLabel = styled.label<Props>`
	cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
	display: flex;
	flex-direction: column;
	height: 100%;
`
